import ExtensionIcon from '@mui/icons-material/Extension';
import CardsGridSubmenu from '../../../common/components/cardsGrid/cardsGridSubmenu';
import BasicLayout from '../../../common/layouts/basicLayout';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { CardsGridItem } from '../../../common/components/cardsGrid/cardsGrid';
import ReceiptIcon from '@mui/icons-material/Receipt';

const cover: CardsGridItem = {
  title: 'Rolex',
  icon: ReceiptIcon,
  path: '/integracao',
};

const gridItems: CardsGridItem[] = [
  {
    title: 'TXT EDI',
    icon: DriveFileRenameOutlineIcon,
    path: '/integracao/rolex/edi',
  },
  {
    title: 'Correspondências',
    icon: ImportExportIcon,
    path: '/integracao/rolex/correspondencias',
  },
];

const RolexPage = () => {
  return (
    <BasicLayout title={'Rolex'} icon={<ExtensionIcon color={'secondary'} />}>
      <CardsGridSubmenu cover={cover} items={gridItems}></CardsGridSubmenu>
    </BasicLayout>
  );
};

export default RolexPage;
